<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('materialsupply_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-materialsupply-show">
      <v-img
        class = "ma-2"
        max-height="250"
        max-width="250"
        lazy-src="@/assets/imagenotfound.png"
        :key="componentKey"
        :src="imageurlItem"
      >
        <ImageForm
          ref="updateForm"
          :item="item"
          v-if="userHasAccess('materialsupply_edit')"
        />
          <v-btn
            color="secondary"
            small
            absolute
            bottom
            right
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
      </v-img>
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.material.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('profile.material.namepub') }}</strong></td>
              <td>
                                    {{ item['namePub'] }}
              </td>

            </tr>

            <tr>
              <td><strong>{{ $t('profile.material.parent') }}</strong></td>
              <td>
                                    <span v-if="item['parent']">{{ item['parent'].name }}</span>
              </td>

              <td><strong>{{ $t('profile.material.version') }}</strong></td>
              <td>
                                    {{ item['version'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.material.machine') }}</strong></td>
              <td>
                  <ul v-for="(object, attr) in item['machine']" :key="attr">
                    <li>
                      <span ><router-link class="routerLink" :to="{ name: 'MachineShow', params: { id:  object['@id']}  }">{{ object.name }}</router-link></span>
                    </li>
                  </ul>
              </td>
              <td><strong>{{ $t('global.archive') }}</strong></td>
              <td>
                          {{ item['archive'] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <template>
        <div class="materialsupplysub-list">
          <Toolbar/>

          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12>
                <h1>{{$t('profile.material.subsupplies')}}</h1>
              </v-flex>
              <v-flex lg12>
                <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                  <MaterialSupplySubFilterForm
                    ref="filterForm"
                    :values="filters"
                    slot="filter"
                  />
                </DataFilter>

                <br />

                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
        :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
                  @click:row="showHandlerSubEvent"
                >
                      <template slot="item.input" slot-scope="{ item }">
                        {{ $n(item['input']) }}
                      </template>

                      <ActionCell
                      slot="item.action"
                      slot-scope="props"
                      :handle-show="() => showHandlerSub(item,'MaterialSupplySub',props.item)"
                      ></ActionCell>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <ProducttypefileList v-if="item"
            ref="ProducttypefileList"
            :materialSupplyParent="[item['@id']]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
            <div v-if="changeLog" class="table-changelog-show">
              <br />
              <Toolbar :handle-edit="() => editSubHandler(changeLog,'ChangeLog')" :hasAccess="userHasAccess('changelog_edit')" >
                <template slot="left">
                  <v-toolbar-title class="hidden-md-and-down">
                    <h1><v-icon large>mdi-math-log</v-icon>{{ $t('version.changelog.changelog') }}</h1>
                  </v-toolbar-title>
                </template>
              </Toolbar>

              <br />
              <v-simple-table>
                <template slot="default">
                  <thead>
                    <tr>
                      <th>{{ $t('global.field') }}</th>
                      <th>{{ $t('global.value') }}</th>

                      <th>{{ $t('global.field') }}</th>
                      <th>{{ $t('global.value') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>{{ $t('version.changelog.name') }}</strong></td>
                      <td>
                                            {{ changeLog['name'] }}
                      </td>

                    </tr>
                    <tr>
              <td><strong>{{ $t('version.changelog.newfeatures') }}</strong></td>
              <td>
                <span  class="tablehtmleditor" v-html="item['changeLog'].newFeatures"></span>
              </td>

              <td><strong>{{ $t('version.changelog.bugfixes') }}</strong></td>
              <td>
                  <span  class="tablehtmleditor" v-html="item['changeLog'].bugFixes"></span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('version.changelog.knownbugs') }}</strong></td>
              <td>
                   <span  class="tablehtmleditor" v-html="item['changeLog'].knownBugs"></span>
              </td>

              <td><strong>{{ $t('version.changelog.notes') }}</strong></td>
              <td>
                  <span  class="tablehtmleditor" v-html="item['changeLog'].notes"></span>
              </td>
            </tr>
                    <tr>
                      <td><strong>{{ $t('version.changelog.developexternal') }}</strong></td>
                      <td>
                                            {{ changeLog['developExternal'] }}
                      </td>

                      <td><strong>{{ $t('version.changelog.developer') }}</strong></td>
                      <td>
                                  <span v-if="changeLog['developer']">{{ changeLog['developer'].login }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>{{ $t('version.changelog.start') }}</strong></td>
                      <td>
                                {{ formatDate(changeLog['start'], 'long') }}
                      </td>

                      <td><strong>{{ $t('version.changelog.end') }}</strong></td>
                      <td>
                                  {{ formatDate(changeLog['end'], 'long') }}
                      </td>
                    </tr>

                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>
        </v-row>
      </v-container>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import MaterialSupplySubFilterForm from '../../components/materialsupplysub/Filter';
import DataFilter from '../../components/DataFilter';
import ImageForm from '../../components/ImageForm.vue';
import FileMixin from '../../mixins/FileMixin';
const servicePrefix = 'MaterialSupply';
import ProducttypefileList from '../producttypefile/List';

export default {
  name: 'MaterialSupplyShow',
  servicePrefix,
  components: {
    Loading,
    Toolbar,
    ActionCell,
    MaterialSupplySubFilterForm,
    DataFilter,
    ImageForm,
    ProducttypefileList
  },
  data() {
    return {
      filter: '250x250',
      headers: [
        { text: this.$t('profile.material.input'), value: 'input' },
        { text: this.$t('profile.material.medium'), value: 'medium.name' },
        { text: this.$t('profile.material.feedspec'), value: 'feedSpec.name' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'materialSupply' : this.$route.params.id,
      },
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      changeLogData: null,
    };
  },
  mixins: [ListMixin,ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('materialsupply', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('materialsupply', ['find']),
    ...mapGetters('materialsupplysub', {
      items: 'list'
    }),
    ...mapFields('materialsupplysub', {
      isLoading: 'isLoading'
    }),
    ...mapFields('materialsupplysub', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    ...mapGetters('materialsupply',{
      dataMaterialsupply: 'data',
    }),
    ...mapState('materialsupply', {
      updatedata: 'updatedata',
      error: 'error',
      isLoading: 'isLoading',
    }),
    changeLog: {
      get() { return this.changeLogData },
       set(value) { this.changeLogData = value; }
    }
  },
  methods: {
    ...mapActions('materialsupply', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    }),
    ...mapActions('materialsupplysub', {
      getPage: 'fetchAll',
    }),
    ...mapActions({
      materialsupplyGetSubItem: 'materialsupply/subItem'
    }),
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'MaterialSupplySub',value);
    },

  },
  watch: {
    updatedata: function (updatedata) {
      if (this.item) {
        if (updatedata == this.item['@id']+ '/'+ 'change_log') {
          this.changeLog = this.dataMaterialsupply(this.item['@id']+ '/'+ 'change_log');
        }
      }
    },
    item: function (item) {

      if(item) {
        if (! this.dataMaterialsupply(item['@id']+ '/'+ 'change_log')) {
          this.materialsupplyGetSubItem({id: item['@id'], data: 'change_log'});
        } else {
          this.changeLog = this.dataMaterialsupply(this.item['@id']+ '/'+ 'change_log');
        }
      }
    }
  }
};
</script>
